var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58506 8.58691C8.21005 8.96206 7.99942 9.47082 7.99951 10.0013C7.99961 10.5317 8.21041 11.0404 8.58556 11.4154C8.96071 11.7904 9.46947 12.0011 9.99992 12.001C10.5304 12.0009 11.039 11.7901 11.4141 11.4149M14.681 14.673C13.2782 15.5507 11.6547 16.0109 10 16C6.4 16 3.4 14 1 10C2.272 7.88003 3.712 6.32203 5.32 5.32603M8.18 4.18003C8.77904 4.05876 9.38881 3.99845 10 4.00003C13.6 4.00003 16.6 6.00003 19 10C18.334 11.11 17.621 12.067 16.862 12.87M1 1L19 19",
    stroke: "#999EA1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/showPasswordIcon.4e5170b3e41c0fca6d21c4d2fb1fc76c.svg";
export { ForwardRef as ReactComponent };